export default __webpack_public_path__ + "assets/images/a800ddb8d47eabd34ca173f03db459ed.png";